import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { enUS } from './locales/en-US';
import { zhCN } from './locales/zh-CN';
import { authZhCN } from '@/features/auth/i18n/zh-CN';
import { authEnUS } from '@/features/auth/i18n/en-US';
import { applyDocumentLocale, readInitialLocale, type SupportedLocale } from './locale';

const initialLocale = readInitialLocale();
void i18n.use(initReactI18next).init({
  resources: {
    'zh-CN': { ...zhCN, auth: authZhCN },
    'en-US': { ...enUS, auth: authEnUS },
  },
  lng: initialLocale,
  fallbackLng: 'zh-CN',
  supportedLngs: ['zh-CN', 'en-US'],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});
applyDocumentLocale(initialLocale);

export function currentLocale(): SupportedLocale {
  return i18n.resolvedLanguage === 'en-US' ? 'en-US' : 'zh-CN';
}
export { i18n };
